export const getFullName = ({
  firstName,
  namePrefix,
  lastName,
}: {
  firstName?: string
  namePrefix?: string
  lastName?: string
}): string => {
  return [firstName, namePrefix, lastName]
    .map((p) => p?.trim())
    .filter(Boolean)
    .join(" ")
}
